import { Area } from '@src/main/modules/common/area/domain/Area';
import { findAllDashboards } from '@src/main/modules/common/dashboard/application/find/findAllDashboards';
import { Dashboard, DashboardCreate } from '@src/main/modules/common/dashboard/domain/Dashboard';
import { DashboardRepository } from '@src/main/modules/common/dashboard/domain/DashboardRepository';
import { useError } from '@src/main/ui/components/common/error/hooks/useError';
import { useAreaContext } from '@src/main/ui/providers/area/AreaContextProvider';
import { useEffect, useState } from 'react';

export const useDashboardUseCases = (dashboardRepository: DashboardRepository) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [dashboards, setDashboards] = useState<Dashboard[] | undefined>();
  const [selectedDashboard, setSelectedDashboard] = useState<Dashboard | undefined>();
  const { areas } = useAreaContext();
  const { addError } = useError();
  useEffect(() => {
    if (areas) {
      reloadDashboards(dashboardRepository, areas, setDashboards, setIsLoading).catch(addError);
    }
  }, [addError, areas, dashboardRepository]);

  const addDashboard = async (dashboard: DashboardCreate) => {
    await dashboardRepository.put(dashboard);
    if (areas) {
      await reloadDashboards(dashboardRepository, areas, setDashboards, setIsLoading);
    }
  };

  const deleteDashboard = async (dashboardId: string) => {
    await dashboardRepository.delete(dashboardId);
    if (areas) {
      await reloadDashboards(dashboardRepository, areas, setDashboards, setIsLoading);
    }
  };

  return {
    isLoading,
    dashboards,
    selectedDashboard,
    setSelectedDashboard,
    addDashboard,
    deleteDashboard,
  };
};

const reloadDashboards = async (
  dashboardRepository: DashboardRepository,
  areas: Area[],
  setDashboards: (dashboards: Dashboard[]) => void,
  setIsLoading: (state: boolean) => void,
) => {
  setIsLoading(true);
  const dashboardsFound: Dashboard[] = await findAllDashboards(dashboardRepository, areas);
  setDashboards(dashboardsFound.slice().sort((a, b) => a.name.localeCompare(b.name)));
  setTimeout(() => setIsLoading(false), 100);
};
